import React from "react";
import { TimePicker, ConfigProvider } from "antd";
import dayjs from "dayjs";

import { FaChevronDown } from "react-icons/fa";

import { Images, Colors } from "../../config";

const format = "h:mm a";

const TimeslotTimepicker = ({
  text,
  placeholder = "Select time",
  value,
  ...props
}) => {
  return (
    <div className="p-2 rounded-xl border border-main flex gap-2 items-center">
      <div className="flex flex-col">
        <div className="text-main font-semibold text-[0.75em]">{text}</div>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: Colors.main,
            },
          }}
        >
          <TimePicker
            prefix={
              <img src={Images.TimeslotDropdownClock} className="h-[1em]" />
            }
            use12Hours
            format={format}
            suffixIcon={null}
            variant="borderless"
            minuteStep={30}
            hourStep={1}
            //   needConfirm={false}
            placeholder={placeholder}
            value={value ? dayjs(value, format) : null}
            {...props}
          />
        </ConfigProvider>
      </div>
      <FaChevronDown />
    </div>
  );
};

export default TimeslotTimepicker;
